import { Module } from 'vuex';
import { DomainAccountState } from './types';
import { RootState } from '../../types';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: DomainAccountState = {
    domainAccounts: undefined,
    domainAccountCount: 0,
    domainAccountDetails: {
        account: undefined,
        domain: undefined,
    },
    wkDomainAccounts: undefined,
    wkDomainAccountCount: 0,
    domainRandomizableAccounts: undefined,
    domainRandomizableAccountCount: 0,
    domainRandomizableAccountType: undefined,
    search: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    directSearch: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    show: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    create: {
        isProcessing: false,
        isCreated: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    update: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    destroy: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    connection: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    randomizableAccount: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
};

const namespaced: boolean = true;

export const domainAccount: Module<DomainAccountState, RootState> = {
    namespaced,
    state,
    actions,
    mutations,
};
